export enum FieldType {
  Text = "text",
  Textarea = "textarea",
  Boolean = "boolean",
  Color = "color",
}

export interface FieldConfig {
  yamlKey: string;
  section: string;
  label: string;
  type: FieldType;
  placeholder?: string;
  description?: string;
  defaultValue?: string | boolean;
}

export interface ToolDependency {
  _id: string;
  type: string;
  value: string;
  description: string;
  transport: string;
  url: string;
}

export type ToolDependencyFieldKey = Exclude<keyof ToolDependency, "_id">;

export interface ToolDependencyFormField {
  key: ToolDependencyFieldKey;
  label: string;
  placeholder: string;
  inputType?: "text" | "url" | "select";
  options?: { label: string; value: string }[];
  disabled?: boolean;
  tooltip?: string;
}

export type ToolDependencyFormRow =
  | { columns: 1; fields: [ToolDependencyFormField] }
  | { columns: 2; fields: [ToolDependencyFormField, ToolDependencyFormField] };

export type FieldValues = Record<string, string | boolean>;
